import { BusinessKrn } from './businessinformation/BusinessKrn';
import { CompanyName } from './businessinformation/CompanyName';
import { FcaNumber } from './businessinformation/FcaNumber';
import { IsRegistered } from './businessinformation/IsRegistered';
import { LegalForm } from './businessinformation/LegalForm';
import { OperationalAddress } from './businessinformation/OperationalAddress';
import { Persons } from './businessinformation/Persons';
import { ProductChannel } from './businessinformation/ProductChannel';
import { RegisteredAddress } from './businessinformation/RegisteredAddress';
import { RegistrationAuthority } from './businessinformation/RegistrationAuthority';
import { RegistrationCountry } from './businessinformation/RegistrationCountry';
import { RegistrationId } from './businessinformation/RegistrationId';
import { ShouldAutoCaptureOrders } from './businessinformation/ShouldAutoCaptureOrders';
import { SubjectToVat } from './businessinformation/SubjectToVat';
import { VatId } from './businessinformation/VatId';
export const BusinessInformation = {
    business_krn: BusinessKrn,
    company_name: CompanyName,
    fca_number: FcaNumber,
    is_registered: IsRegistered,
    legal_form: LegalForm,
    operational_address: OperationalAddress,
    persons: Persons,
    product_channel: ProductChannel,
    registered_address: RegisteredAddress,
    registration_authority: RegistrationAuthority,
    registration_country: RegistrationCountry,
    registration_id: RegistrationId,
    should_auto_capture_orders: ShouldAutoCaptureOrders,
    subject_to_vat: SubjectToVat,
    vat_id: VatId,
};
